import { Box, ListItemButton, ListItemText } from "@mui/material";
import { Export24Px } from "@qubit/autoparts";

import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { mixpanelTrack } from "~/lib/mixpanel-tracking";

type LogoutButtonProps = {
  trackedContextName: string;
};

const LogoutButton = ({ trackedContextName }: LogoutButtonProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    mixpanelTrack({
      trackedPageName: trackedContextName,
      type: "Button Click",
      label: "Logout"
    });
    navigate("/logout");
  };
  return (
    <ListItemButton key="Logout" onClick={handleLogout}>
      <Box
        sx={{
          width: "40px",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Export24Px aria-label="logout icon" />
      </Box>
      <ListItemText
        primary={t("nav.link.logout")}
        sx={{
          fontSize: 16,
          padding: "0 14px",
          color: "text.primary"
        }}
      />
    </ListItemButton>
  );
};
export default LogoutButton;
